export default __webpack_public_path__ + "static/media/Sport-min.674dbeb6.png";